
import { defineComponent, PropType } from 'vue';
import { OdooAccounts } from '@/lib/api/odoo.api';

export default defineComponent({
  props: {
    items: {
      type: Object as PropType<OdooAccounts[]>,
      required: false,
      default: null,
    },
  },
});
